import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { BootStateService } from './shared/services/boot-state.service';
import { LoadingSplashComponent } from './shared/components/loading-splash/loading-splash.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingSplashComponent],
  template: `
    <app-loading-splash />
    <router-outlet />
  `,
})
export class AppComponent implements OnInit {
  private auth = inject(AuthService);
  private boot = inject(BootStateService);

  ngOnInit(): void {
    this.auth.bootstrapFromFragment();
    this.boot.markReady();
  }
}
